import React from 'react'
import GooglePayButton from '@google-pay/button-react'
import Box from '@mui/material/Box';

const GooglePayOption = () => {
    return <Box sx={{ ml: 2 }}>
        <GooglePayButton
            environment="TEST"
            paymentRequest={{
                apiVersion: 2,
                apiVersionMinor: 0,
                allowedPaymentMethods: [
                    {
                        type: 'CARD',
                        parameters: {
                            allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
                            allowedCardNetworks: ['MASTERCARD', 'VISA'],
                        },
                        tokenizationSpecification: {
                            type: 'PAYMENT_GATEWAY',
                            parameters: {
                                gateway: 'mpgs',
                                gatewayMerchantId: 'BCR2DN4TWCV3VOIQ',
                            },
                        },
                    },
                ],
                merchantInfo: {
                    merchantId: '12345678901234567890',
                    merchantName: 'ePridim',
                },
                transactionInfo: {
                    totalPriceStatus: 'FINAL',
                    totalPriceLabel: 'Total',
                    totalPrice: '100.00',
                    currencyCode: 'INR',
                    countryCode: 'IN',
                },
                shippingAddressRequired: false,
                callbackIntents: ['PAYMENT_AUTHORIZATION']
            }}
            onLoadPaymentData={PaymentRequest => {
                console.log('load payment data', PaymentRequest);
            }}
            existingPaymentMethodRequired={false}
            buttonColor="black"
            buttonType='pay'
            buttonSizeMode='static'
            onCancel={() => console.log("payment has been cancelled!")}
            onPaymentAuthorized={paymentData => {
                console.log(" paymentData ", paymentData)
                return { 'transactionState': 'SUCCESS' }
            }}
        />
    </Box>
}

export default GooglePayOption;
